// extracted by mini-css-extract-plugin
module.exports = {"alert-icon":"style_alert-icon__S1LFV"};